import { useQuery } from '@apollo/client';
import { GET_CLOSEST_ASSIGNED_EVENT_DATE } from '../../../queries/getClosestAssignedEventDateQuery';
import { useCacheNetworkQuery } from '@apollo-internal/hooks/useCacheNetworkQuery';
import GET_ATM_CALENDAR from '../../../queries/getATMCalendarQuery';
import { useSelectedDateStore } from '../../../CalendarStore';
import {
  formatDate,
  getFirstDayOfTheWeek,
  getLastDayOfTheWeek
} from '@shared/services/dateService';
import { useShallow } from 'zustand/shallow';

export const useGetATMCalendarQuery = args => {
  const { variables, onCompleted } = args;
  const { externalUserId, eventPhase } = variables;

  const [selectedDate, setSelectedDate, previousSelectedDate] = useSelectedDateStore(
    useShallow(state => [state.selectedDate, state.setSelectedDate, state.previousSelectedDate])
  );

  const { loading: closestDateDataLoading, error: closestDateDataError } = useQuery(
    GET_CLOSEST_ASSIGNED_EVENT_DATE,
    {
      variables: {
        externalUserId,
        eventPhase
      },
      onCompleted: data => {
        setSelectedDate(getSelectedDate(data.getClosestAssignedEventDate, previousSelectedDate));
      },
      skip: selectedDate
    }
  );

  const {
    data: calendarData,
    loading: calendarDataLoading,
    error: calendarDataError
  } = useCacheNetworkQuery(GET_ATM_CALENDAR, {
    variables: {
      start: formatDate(getFirstDayOfTheWeek(selectedDate)),
      end: formatDate(getLastDayOfTheWeek(selectedDate)),
      externalUserId,
      eventPhase
    },
    onCompleted: data => {
      onCompleted(data);
    },
    skip: !selectedDate
  });

  return {
    data: calendarData,
    loading: closestDateDataLoading || calendarDataLoading,
    error: closestDateDataError || calendarDataError
  };
};

const getSelectedDate = (getClosestAssignedEventDate, previousSelectedDate) =>
  getClosestAssignedEventDate ? new Date(getClosestAssignedEventDate) : previousSelectedDate;
